import Container from '../../atoms/Container';
// import PageHeader from '../../molecules/Header';
import { Typography } from '../../molecules/Typography';
import { ExerciseList } from '../../organism/ExerciseList';

import { useExerciseHook } from '../../../hooks/exercise';
import { ExerciseAction, IExercise } from '../../../models/exercise';
import { Button } from '../../atoms/Button';
import { AnswersHolder } from '../../molecules/AnswersHolder';
import ExercisePagination from '../../molecules/ExercisePagination';
// import PrintComponent from '../../organism/PrintComponent';
// import { Colors } from '../../../models/disciplines';
// import { DnaIcon } from 'morpheus-ui';
import { Fragment } from 'react';
import ContentLoader from 'react-content-loader';
//import { getDisciplineIcon } from '../../../utils/new_discipline';
import NewPrintComponent from '../../organism/PrintComponent/newPrintComponent';

import { DnaIcon } from 'morpheus-ui';
import { Colors } from '../../../models/disciplines';
import { getDisciplineIcon } from '../../../utils/new_discipline';
import { usePrintComponentStore } from '../../organism/PrintComponent/store/usePrintComponentStore';
import ExercisePaper from '../PrintPaper/exercises';
// import Lock from '../../organism/Lock';

interface ExerciseProps {
  title?: string | null;
  discipline?: string | null;
  exercises: IExercise[];
  initialPage?: number;
  exerciseType?: 'default' | 'revision';
  showTotalExercises?: boolean;
  showExerciseNavigation?: boolean;
  showContentList?: boolean;
  isLoading?: boolean;
  onPageChange: (page: number) => void;
  onExerciseChange: (exercise: IExercise, action?: ExerciseAction) => void;
  onClickContentList?: () => void;
  onEndRevision?: () => void;
}

const Exercise = ({
  title = null,
  discipline = null,
  exercises,
  initialPage = 0,
  exerciseType = 'default',
  showTotalExercises = false,
  showExerciseNavigation = true,
  showContentList = false,
  isLoading = false,
  onPageChange,
  onExerciseChange,
  onClickContentList = () => {},
  onEndRevision = () => {},
}: ExerciseProps) => {
  const { setData } = usePrintComponentStore();

  const {
    currentPage,
    isOpenPrint,
    goToExercise,
    goToNextExercise,
    goToPreviousExercise,
    checkExercise,
    scrollToBottom,
    setIsOpenPrint,
  } = useExerciseHook(initialPage);

  const totalExercises = exercises.length;
  const currentExercise =
    totalExercises > 0 ? exercises[currentPage] : ({} as IExercise);
  const isAllExercisesDone =
    exercises.filter((exercise) => exercise.done).length >= totalExercises;

  return (
    <Container>
      {!currentExercise || !currentExercise.alternatives ? (
        <Fragment>
          <ContentLoader
            backgroundColor={'#a7adba'}
            foregroundColor={'#c0c5ce'}
            viewBox='0 0 500 30'
          >
            <rect x='0' y='2' rx='2' ry='2' width='100' height='15' />
          </ContentLoader>
          <ContentLoader
            backgroundColor={'#a7adba'}
            foregroundColor={'#c0c5ce'}
            viewBox='0 0 500 80'
          >
            <rect x='0' y='2' rx='2' ry='2' width='100%' height='70' />
          </ContentLoader>
          {Array.from({ length: 5 }, (_, index) => (
            <ContentLoader
              key={`${index}_loader`}
              backgroundColor={'#a7adba'}
              foregroundColor={'#c0c5ce'}
              viewBox='0 0 500 24'
            >
              <rect x='0' y='2' rx='2' ry='2' width='100%' height='20' />
            </ContentLoader>
          ))}
        </Fragment>
      ) : (
        <div className='flex flex-col gap-xxl pb-20'>
          <NewPrintComponent 
            type='exercise'
            isOpen={isOpenPrint}
            onClose={() => setIsOpenPrint(false)}
            title={title ?? ""}
            subtitle={discipline ?? "Interdisciplinar"}
          >
            <ExercisePaper 
              cols="split" 
              size="default" 
              color={(discipline as Colors) ?? 'anatomia-superior'}
              iconType='svg'
              icon={getDisciplineIcon(discipline || '') || DnaIcon}
              title={title ?? ""}
              module={discipline ?? "Anatomia"}
            /> 
          </NewPrintComponent>
          {showTotalExercises && (
            <Typography size='small'>
              {`${totalExercises} exercícios`}
            </Typography>
          )}
          {showExerciseNavigation && (
            <div className='flex flex-col gap-md'>
              <AnswersHolder
                answers={exercises}
                onSelectedAnswer={(index) => {
                  goToExercise(index);
                  onPageChange(index);
                }}
              />
              <div className='flex justify-between'>
                <Typography size='small'>
                  Navegue pela lista de exercícios
                </Typography>
                {exerciseType !== 'revision' && (
                  <Button
                    variant='text'
                    LeftIcon='print'
                    size='small'
                    onClick={() => {
                      setData(exercises)
                      setIsOpenPrint(true)
                    }}
                  >
                    <Typography>Imprimir lista de exercícios</Typography>
                  </Button>
                )}
              </div>
            </div>
          )}

          <div className='flex items-center justify-between'>
            <ExerciseList
              data={exercises}
              isLoading={isLoading}
              tryAgainEnabled={exerciseType !== 'revision'}
              onExerciseChange={(exercise, action) => {
                onExerciseChange(exercise, action);
              }}
            />
          </div>
        </div>
      )}
      <ExercisePagination
        page={currentPage}
        totalPages={totalExercises}
        currentExercise={currentExercise}
        showContentList={showContentList}
        enableRevision={exerciseType === 'revision' && isAllExercisesDone}
        isLoading={isLoading}
        onPrevious={() => goToPreviousExercise(totalExercises, onPageChange)}
        onNext={() => goToNextExercise(totalExercises, onPageChange)}
        onCheck={() => {
          scrollToBottom(
            onExerciseChange(checkExercise(currentExercise), 'verifyAnswer')
          );
        }}
        onClickContentList={() => onClickContentList()}
        onEndRevision={() => onEndRevision()}
      />
    </Container>
  );
};

export default Exercise;
